module.exports = __webpack_public_path__ + "img/back-arrow.565a5f0b.svg";